// extracted by mini-css-extract-plugin
export default {"verify_email":"VerifyEmail_verify_email__ZZI4l","go_home_button":"VerifyEmail_go_home_button__qjDrG","verify_email_layout":"VerifyEmail_verify_email_layout__cu5Ra"};